module.exports = __webpack_public_path__ + "static/media/8OLA1.09b03a99.jpg";